import { WageringConditionBonus } from 'config/types/bonus/userBonus'
import React from 'react'

import Box from 'UIKit/Box/Box'
import DepositBonusCondition from '../BonusContentCondition/DepositBonusCondition'
import BonusContentAmount from '../Common/BonusContentAmount'
import BonusContentWager from '../Common/BonusContentWager'
import BonusItemName from '../Common/BonusItemName'

interface BonusItemProps {
  bonus: WageringConditionBonus
  isShowMonochrome?: boolean
}

const UsedWageringBonusContent: React.FC<BonusItemProps> = ({ bonus, isShowMonochrome }) => {
  return (
    <Box height="100%">
      <BonusItemName bonus={bonus} mb="8px" />

      {bonus.bonusAmount?.token ? (
        <Box mt="8px">
          <BonusContentAmount bonus={bonus} />
          <BonusContentWager bonus={bonus} mt="8px" isShowMonochrome={isShowMonochrome} />
        </Box>
      ) : (
        <Box mt="8px">
          <DepositBonusCondition bonus={bonus} />
        </Box>
      )}
    </Box>
  )
}

export default UsedWageringBonusContent
